import { render, staticRenderFns } from "./FactSheetView.vue?vue&type=template&id=0b3ca83c&"
import script from "./FactSheetView.vue?vue&type=script&lang=js&"
export * from "./FactSheetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports